import { css } from '@emotion/css';
import { colors } from '@editor2/styles/colors';

export const htmlBlock = css`
	max-height: 500px;
	width: 100%;
	overflow: auto;

	.CodeMirror {
		height: auto;
		border: 1px solid ${colors.border};
		border-radius: 4px;
		font-size: 12px;
		font-family: 'JetBrains Mono', monospace;
		color: ${colors.mainText};

		.CodeMirror-line {
			font-variant-ligatures: none;
		}
	}

	.cm-spell-error {
		text-decoration: underline dotted red;
	}
`;
